<template>
    <div v-if="loading == false">
        <ChirpReport
            :data_source="rows"
            :export_report="export_report"
            :column_meta="headers"
            :preFormattedData="true"
            :target_page="targetPage"
            :loadingColumns="loadingTable"
            ignoreDateConversion
            :totalCount="totalCount"
            :storeKey="storeKey"
            :useOverride="useOverride"
            :hide_speed_date="false"
            @cancelOverride="useOverride = false"
        />
    </div>
</template>
<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'reports';
    const report = 'daily_transaction';
    import ChirpReport from '@/components/general/list/ChirpReport';
    import dayjs from '@/util/dayjs';
    export default {
        name: 'DailyTransaction',
        components: { ChirpReport },
        props: {
            overrideFilter: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                rows: [],
                headers: [
                    { field: 'payment_date', headerText: 'Payment Date & Time', allowSorting: true, width: 250 },
                    { field: 'client', headerText: 'Client', allowSorting: true, width: 200 },
                    { field: 'payment_method', headerText: 'Payment Method', allowSorting: true },
                    { field: 'check_no', headerText: 'Check #', allowSorting: true },
                    { field: 'description', headerText: 'Details', allowSorting: true },
                    { field: 'invoice_id', headerText: 'Invoice #', allowSorting: true },
                    { field: 'amount', headerText: 'Payment Amount', allowSorting: true, align: 'Right' },
                ],
                targetPage: '',
                useOverride: false,
                totalCount: 0,
                loading: true,
                loadingTable: false,
                criteriaProps: {},
                export_report: 'daily_transaction'
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'dailyTransactions';
            },
        },
        methods: {
            async load_data(criteria = this.criteria) {
                const body = {
                    criteria: {
                        ...criteria,
                        report,
                    },
                };
                const res = await this.$api.post(`/${api_root}`, body);
                this.rows = res.data.rows.map((row) => ({
                    payment_date: row.payment_date ? dayjs(row.payment_date).format('MM/DD/YYYY h:mma') : '--',
                    client: row.client || '--',
                    payment_method: row.payment_method ? row.payment_method.toTitleCase() : '--',
                    check_no: row.check_no || '--',
                    description: row.description || '--',
                    invoice_id: row.invoice_id || '--',
                    amount: row.amount ? this.$getCurrency(row.amount) : '--',
                }));
                this.totalCount = res.data.total_count;

                if (
                    !criteria?.default_date_range ||
                    criteria?.default_date_range !== res.data.default_date_range
                ) {
                    this.$store.commit('filters/updateFilter', {
                        stateKey: this.storeKey,
                        criteria: {
                            ...criteria,
                            default_date_range: res.data.default_date_range,
                        },
                    });
                }

                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter,
                    });
                }

                if (!this.criteria.sort || (this.criteria.sort && Object.keys(this.criteria.sort).length === 0)) {
                    let copy = JSON.parse(JSON.stringify(this.criteria));
                    copy.sort = {
                        payment_date: 'desc',
                    };
                    this.$store.commit('filters/updateFilter', {
                        stateKey: this.storeKey,
                        criteria: copy
                    });
                    return;
                }
                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria,
                    });
                }
                this.criteriaProps = criteria;
                await this.load_data();
            },
        },
        async created() {
            await this.init();
        },
        watch: {
            criteria: {
                deep: true,
                async handler(newVal, oldVal) {
                    let updatedNewVal = { ...newVal };

                    const newStr = JSON.stringify(updatedNewVal);
                    const oldStr = JSON.stringify(oldVal);
                    if (newStr !== oldStr) {
                        await this.load_data();
                    }
                },
            },
        },
    };
</script>
